export default "__VITE_ASSET__CASq5TXR__"